import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTapasComponent } from './simple-icons-tapas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTapasComponent ],
    exports:      [ SimpleIconsTapasComponent ],
    bootstrap:    []
})
export class SimpleIconsTapasModule {}
